const Hooks = {};

/* TOAST */
const toastTrigger = (lv) => {
  const { type, message } = lv.el.dataset;

  // Allow "error" flashes to be called with either :danger or :error
  let toastType = '';
  if (type === 'error') {
    toastType = 'danger';
  } else {
    toastType = type;
  }

  window.toast({
    message: decodeURI(message),
    type: `is-${toastType}`,
  });

  // Send clear event to server
  lv.pushEvent('clear-alerts', null);
};
Hooks.ToastTrigger = {
  mounted() {
    toastTrigger(this);
  },
  updated() {
    toastTrigger(this);
  },
};

export default Hooks;
